export default "__VITE_ASSET__CZaJI8rd__"